import {
  List,
  Datagrid,
  TextField,
  DateField,
  SelectInput,
  TextInput,
  FilterButton,
  TopToolbar,
  CreateButton,
  ExportButton,
  SelectField,
  usePermissions,
  BulkDeleteButton,
  BulkExportButton,
  useRecordContext,
} from 'react-admin';
import { Chip } from '@mui/material';

const entityTypeChoices = [
  { id: 'cricket_player', name: 'Cricket Player' },
  { id: 'movie', name: 'Movie' },
  { id: 'movie_song', name: 'Movie Song' },
  { id: 'city', name: 'City' },
  { id: 'company', name: 'Company' },
];

const verificationStatusChoices = [
  { id: 'unverified', name: 'Unverified' },
  { id: 'pending_review', name: 'Pending Review' },
  { id: 'verified', name: 'Verified' },
];

const entityFilters = [
  <TextInput key="q" source="q" label="Search" alwaysOn />,
  <SelectInput
    key="entity_type"
    source="entity_type"
    choices={entityTypeChoices}
    label="Entity Type"
  />,
  <SelectInput
    key="verification_status"
    source="verification_status"
    choices={verificationStatusChoices}
    label="Verification Status"
  />,
];

interface VerificationStatusFieldProps {
  source?: string;
  label?: string;
}

const VerificationStatusField = (_props: VerificationStatusFieldProps) => {
  const record = useRecordContext();
  const status = record?.verification_status || 'unverified';
  const colorMap: Record<string, 'default' | 'warning' | 'success'> = {
    unverified: 'default',
    pending_review: 'warning',
    verified: 'success',
  };
  return (
    <Chip
      label={status.replace('_', ' ')}
      color={colorMap[status] || 'default'}
      size="small"
    />
  );
};

const ListActions = () => {
  const { permissions } = usePermissions();
  const canCreate =
    permissions?.role === 'super_admin' ||
    permissions?.permissions?.includes('entities:create');

  return (
    <TopToolbar>
      <FilterButton />
      {canCreate && <CreateButton />}
      <ExportButton />
    </TopToolbar>
  );
};

const BulkActionButtons = () => {
  const { permissions } = usePermissions();
  const canDelete =
    permissions?.role === 'super_admin' ||
    permissions?.permissions?.includes('entities:delete');

  return (
    <>
      <BulkExportButton />
      {canDelete && <BulkDeleteButton />}
    </>
  );
};

export const EntityList = () => (
  <List
    filters={entityFilters}
    actions={<ListActions />}
    sort={{ field: 'updated_at', order: 'DESC' }}
    perPage={25}
  >
    <Datagrid rowClick="show" bulkActionButtons={<BulkActionButtons />}>
      <TextField source="display_name" label="Name" />
      <SelectField
        source="entity_type"
        choices={entityTypeChoices}
        label="Type"
      />
      <VerificationStatusField source="verification_status" label="Status" />
      <DateField source="created_at" label="Created" showTime />
      <DateField source="updated_at" label="Updated" showTime />
    </Datagrid>
  </List>
);
